module.exports = __webpack_public_path__ + "img/border_tl.30308826.svg";